import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {SelectItem} from 'primeng/api';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-multiselect',
    template: `
        <p-chips [class.ng-dirty]="showError"
                 [placeholder]="to.placeholder"
                 [formControl]="formControl"
                 [formlyAttributes]="field"
                 allowDuplicate="false"
        >
        </p-chips>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldChips extends FieldType {
}
